import React from "react";
import MainButton from "../button";

import "./index.scss";

const Footer = ({ isLastStep, disabledCancel, disabledBack, disabledNext, disabledFinish,

    handelCancel, handleBack, handleNext, handleFinish
}) => {


    return (
        <footer className="wizard-footer">
            <div className="buttons">
                {isLastStep ?
                    (
                        <MainButton
                            isDisabled={disabledFinish}
                            text="Finish"
                            variant="success"
                            onClick={handleFinish}
                            className="wizard-footer-item"
                        />
                    ) :
                    (
                        <MainButton
                            isDisabled={disabledNext}
                            text="Next"
                            onClick={handleNext}
                            variant="success"
                            className="wizard-footer-item"
                        />
                    )}

                <>
                    <MainButton
                        isDisabled={disabledBack}
                        text="Back"
                        onClick={handleBack}
                        className="wizard-footer-item"
                    />
                    <MainButton
                        isDisabled={disabledCancel}
                        text="Cancel"
                        variant="error"
                        onClick={handelCancel}
                        className="wizard-footer-item"
                    />
                </>

            </div>
        </footer>
    );
}

export default Footer;